import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  height: 400px;
  padding: 1rem 1rem 0 0.5rem;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

export const Description = styled.div`
  width: 100%;
  float: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin: -40px 0 0 0px;
    overflow: hidden;
    padding: 15px;

    background:${({ theme }) => theme.colors.BG1};
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};

    border-radius: 10px;
    width: 250px;

    span {
      background: ${({ theme }) => theme.colors.LIGHT2};
      padding: 5px;
      color: ${({ theme }) => theme.colors.TEXT1};
      border-radius: 6px;
      font-size: 10px;
      display: flex;
      align-self: center;
    }

    h1 {
      font-size: 26px;
      color: ${({ theme }) => theme.colors.TEXT1};
      margin: 2px 0 0px 0;
      font-weight: 700;
      text-transform: uppercase;
      float: left;
      width: 100%;
      text-align: center;
    }

    h2 {
      font-size: 10px;
      font-weight: normal;
      color: ${({ theme }) => theme.colors.TEXT1};
      float: left;
      width: 100%;
      margin: 0px;
      text-align: center;
    }

    ins {
      float: left;
      width: 100%;
      height: 2px;
      background: ${({ theme }) => theme.colors.LIGHT2};
      margin: 10px 0 10px 0;
    }

    h4 {
      font-size: 10px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      float: left;
      width: 100%;

      b {
        padding-left: 5px;
        color: #9d4817ff;
      }
    }

    h5 {
      font-size: 10px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      float: left;
      width: 100%;
      align-items: center;

      b {
        padding-left: 5px;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 0;
    width: 200px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background:${({ theme }) => theme.colors.BG1};
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
    border-radius: 5px;
    margin-left: -100px;

    i {
      margin: -30px 0 0 0;
      width: 60px;
      height: 60px;

      svg {
        width: 26px;
        fill: #fff;
      }
    }

    div {
      margin: 0px 0 0 0;
      width: 100%;
      float: left;
      background: none;
      border: none;
      box-shadow: none;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px;
      border-radius: 0px;
      overflow: hidden;

      span {
        align-self: flex-start;
      }

      h1 {
        font-size: 12px;
        white-space: normal;
        float: left;
        text-align: left;
        width: 100%;
      }

      h2 {
        font-size: 10px;
        white-space: normal;
        text-align: center;
        text-align: left;
      }

      h3 {
        font-size: 10px;
        width: 100%;
        float: left;
        white-space: normal;
        text-align: center;
      }

      h5 {
        font-size: 8px;
        margin: 0 0 2px 0;
      }

      h4 {
        font-size: 10px;
      }
    }
  }
`;
